import { useEffect, useRef, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { useActions } from '../../../hooks/useActions';
import { useReview } from '../../../hooks/useReview';
import { IComment } from '../../../store/review/review.interface';

export const useCommentForm = (form: any) => {
  const inputRef = useRef<any>(null);
  const { focusForm } = useReview();
  const { setFocusForm } = useActions();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { setShowReviewComments, addComment, setIsAddedComment } = useActions();
  const { commentId, isAddedComment } = useReview();
  const onSubmit: SubmitHandler<IComment> = (data) => {
    addComment({ content: data.content, comment_id: commentId });
    setIsAddedComment(!isAddedComment);
    setFormSubmitted(true);
  };

  const onShowComments = () => {
    if (!form.getValues('content')) return;
    setShowReviewComments(true);
  };

  useEffect(() => {
    if (inputRef.current && focusForm) {
      inputRef.current.focus();
      setFocusForm(false);
    }
  }, [inputRef, focusForm]);
  return { inputRef, formSubmitted, onSubmit, onShowComments };
};
